const defaultState = {
	searchParam: {
		commCdType: 'ALL',
		regId: '',
		commCdTypeName: ''
		// useYn: 'ALL'
	},
	commCdTypePagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	commCdPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	commCdDescPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	commCdDescModal: {
		show: false,
		selectedRow: {}
	},
	commCdLangModal: {
		show: false,
		isButtonOpened: false,
		codeType: 'name',
		groups: {
			currentPage: 1,
			pageUnit: 10,
			totalSize: 0
		}
	},
	pageArray: [10, 30, 50, 100],
	commCdRows: [],
	optionLangs: [],
	commCdTypeRows: [],
	commCdDescRows: [],
	commCdLangRows: [],
	commCdTypeOptions: [],
	// useYnOptions: [],
	currentCommCdType: '',
	commLangType: [],
	gridLangCdype: [],
	msgTypes: [],
	gridMsgTypes: []
};

export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
